import { Component, Prop, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { User } from '@/types/_'
import { getUser } from '@/utils/common'
import { ISolicitacaoChatList } from '../../../../types/interfaces/solicitacao-chat/solicitacao-chat-list.interface'
import BackofficeChatStore from '../../store/backoffice-chat-store'
import BackofficeModalChatStore from '../../store/backoffice-modal-chat-store'

@Component
export default class ComponentFilter extends Vue {
  @Prop({ default: [] }) data: ISolicitacaoChatList[] = []

  public user: User = { ...getUser() }

  headers = [
    { text: 'Nº da reserva', value: 'numeroAgendamento', align: 'center', sortable: false },
    { text: 'Médico', value: 'doctor', sortable: false },
    { text: 'Procedimento', value: 'procedure', sortable: false },
    { text: 'Paciente', value: 'patient', sortable: false },
    { text: 'Hospital', value: 'hospital', sortable: false },
    { text: 'Convênio', value: 'healthAssurance', sortable: false },
    { text: 'Situação', value: 'status', sortable: false },
    { text: 'Responsável', value: 'responsible', sortable: false },
    { text: 'Tempo Aberto', value: 'lastInitializationDate', sortable: false },
    { text: 'Status', value: 'actions', sortable: false },
  ]

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.user.profile.email)
  }

  openChat(data: ISolicitacaoChatList) {
    const solicitationId = data.id
    const chatArea = this.backofficeChatStore.activeTab
    const recipientName = data.medicoNome
    const senderId = this.user.profile.sub
    const senderName = this.user.profile.name

    this.backofficeModalChatStore.reset()
    this.backofficeModalChatStore.openChatModal({
      solicitationId,
      chatArea,
      recipientName,
      senderId,
      senderName,
    })

    this.ga('backoffice-chat', 'abrir-chat')
  }

  formatLastInitializationDate(dateString: string) {
    if (dateString) {
      const initialDate = new Date(dateString)
      const now = new Date()

      const diference = now.getTime() - initialDate.getTime()

      const minutes = Math.round((diference / 1000) / (60))

      // Year scale
      if (minutes > 525600) {
        const days = Math.round(((minutes / 60) / 24) / 365)
        return `${days} y`
      }

      // Day scale
      if (minutes > 1440) {
        const days = Math.round((minutes / 60) / 24)
        return `${days} d`
      }

      // Hour scale
      if (minutes > 60) {
        const hours = Math.round(minutes / 60)
        return `${hours} h`
      }

      // Minutes scale
      return `${minutes} m`
    }

    return ''
  }

  getChatInfo(data: ISolicitacaoChatList) {
    const { chatFinalizado, totalMensagensNaoLidas } = data

    if (chatFinalizado === false) {
      if (totalMensagensNaoLidas! > 0) {
        const number = totalMensagensNaoLidas! >= 1 ? data.totalMensagensNaoLidas : ''
        const text = totalMensagensNaoLidas! > 1 ? 'Novas Mensagens' : 'Nova Mensagem'

        return { icon: 'chat', title: `${number} ${text}`, class: '-orange' }
      }

      return { icon: 'chat_bubble', title: 'Chat Aberto', class: '-yellow' }
    }

    return { icon: 'chat_bubble_outline', title: 'Nenhum Chat', class: '-gray' }
  }

  paginatorChange(page: number) {
    this.paginator.page = page
    this.backofficeChatStore.loadChats()
  }

  get paginator() {
    return this.backofficeChatStore.paginator
  }

  get paginatorButtonsLength() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 10
  }

  get backofficeChatStore() {
    return getModule(BackofficeChatStore, this.$store)
  }

  get backofficeModalChatStore() {
    return getModule(BackofficeModalChatStore, this.$store)
  }
}
